// The paywall refuses to charge anything but the amount on the Pay button
// (`expectedAmountUsd`): the invoice changed after the customer was shown it.
// It answers with a ShHttpException, which reaches us as a GraphQL error whose
// errorCode sits where links.ts reads it.
export const AMOUNT_CHANGED_ERROR_CODE = '99999971'

// The paywall's own wording, in case a gateway drops the error code on the way.
const AMOUNT_CHANGED_MESSAGE = /is now .+, not the .+ you were shown/i

interface GraphQLErrorLike {
  message?: string
  extensions?: { exception?: { response?: { errorCode?: string } } }
}

const isAmountChangedError = (error: GraphQLErrorLike): boolean =>
  error?.extensions?.exception?.response?.errorCode === AMOUNT_CHANGED_ERROR_CODE ||
  AMOUNT_CHANGED_MESSAGE.test(error?.message || '')

export const isAmountChanged = (error: unknown): boolean => {
  const graphQLErrors: GraphQLErrorLike[] = (error as { graphQLErrors?: GraphQLErrorLike[] })
    ?.graphQLErrors || []
  return graphQLErrors.some(isAmountChangedError)
}
